// extracted by css-extract-rspack-plugin
export default {"cls1":"QuestionStyles-cls1_QkZ","cls2":"QuestionStyles-cls2_tbS QuestionStyles-cls1_QkZ"};